/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Popconfirm, Modal, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import './invoice.css';
import {sKeylist} from '../../service/dictionary/dataitem';
import {
    getProductList4,
    setProductUp,
    getProductCategory,
    deleteInvoice,
    invoiceTempTotalAmount,
    confirmReceive
} from '../../service/invoiceManagement';
import {fetchChannelList} from '../../service/home';
import {Store, Actions} from './store';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class InvoiceList extends Reflux.Component {
    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.ouId = window.sessionStorage.getItem('cur_ouId') || '';
        this.state = {
            opts: ['开票管理'],
            key: 0,
            selectedRowKeys: [],
            rows: [],
            total: 0,
            tempTotalAmount: 0,
            tempTotal: 0,
            searchObj: {
                name: '',
                category: [],
                active: '',
                // startDate: d.format('yyyy-MM-dd'),
                // endDate: d.format('yyyy-MM-dd'),
                s: 10,
                p: 1,
                cusName: '',
                purchaseName: '',
                vatInvoiceCode: '',
                vatInvoiceNumber: '',
                taxpayerNumber: '',
                address: '',
                courierNumber: '',
                invoiceDate: '',
                invoiceStarDate: '',
                invoiceEndDate: '',
                // invoiceStarDate: d.format('yyyy-MM-dd'),
                // invoiceEndDate: d.format('yyyy-MM-dd'),
                status: '',
                channel: '',
                signStatus: '',
            },
            categoryData: [],
            button_limits_end: {},
            channel_list: [],
            invoiceOrderStatus: [],
            //signStatus:[],
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.deleteChange = this.deleteChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.batchDownload = this.batchDownload.bind(this);
    }

    /*选择条目*/
    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
        console.log(selectedRowKeys);
    };

    /*筛选*/
    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    setFilterParam(name, value) {
        if (name === 'invoiceDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    invoiceStarDate: value.from,
                    invoiceEndDate: value.end,
                }
            })
        } else if (name === 'orderTime2') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderStartDate: value.from,
                    orderEndDate: value.end,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /* 批量删除 */
    deleteChange() {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        setProductUp(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                self.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    downloadFile(url) {
        window.open(url);
    }

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                cusName: '',
                purchaseName: '',
                vatInvoiceCode: '',
                vatInvoiceNumber: '',
                taxpayerNumber: '',
                address: '',
                courierNumber: '',
                invoiceDate: '',
                invoiceStarDate: '',
                invoiceEndDate: '',
                status: '',
                channel: '',
                channel_list: [],
                signStatus: '',
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';

        self.setState({
            loading: true
        })
        getProductList4(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total || 0,
                    'tempTotalAmount': result.data.totalAmount || 0,
                    'tempTotal': result.data.total || 0,
                    'loading': false
                });
                invoiceTempTotalAmount().then(res => {
                    if (res && res.code == 200) {
                        self.setState({
                            'tempTotalAmount': res.data.totalAmount || 0,
                            'tempTotal': res.data.total || 0
                        });
                    } else {
                        openNotice('error', '数据获取失败', '');
                    }
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    /*初始化渲染执行前调用*/
    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        getProductCategory().then(function (categoryResult) {
            /* 产品分类 */
            if (!categoryResult || categoryResult.code != 200) {
                openNotice('error', '产品分类数据获取失败，请重试', '');
                return;
            }
            self.setState({
                categoryData: categoryResult.data || []
            });
        });
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // var arr = new Array();
                // var arr = [{text: '全部', value: ''}];
                var arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_list: arr});
            }
        });


        sKeylist({sKey: 'INVOICE_ORDER_STATUS'}).then(res => { //状态
            if (res.status) {
                // var arr = new Array();
                var arr = [{text: '全部', value: ''}];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                });
                self.setState({invoiceOrderStatus: arr})
            }
        })

    }

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
        this.initData();
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
    }

    /* 删除开票行信息 */
    deleteRows(id) {
        const self = this;
        deleteInvoice(id).then(res => {
            if (res && res.code == 200) {
                openNotice('success', '删除成功', '');
                self.initData();
            } else {
                openNotice('error', '删除失败', (res && res.message) ? res.message : '');
            }
        })
    }

    /*确认签收*/
    confirmHandle(record, index, value) {
        let self = this;
        confirmReceive(record.id).then(result => {
            if (result && result.status == true) {
                openNotice('success', '确认签收成功', '');
                self.initData();
            } else {
                openNotice('error', '确认签收失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tzOrderSync/exportInvoiceApply?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    batchDownload() {
        const {selectedRowKeys} = this.state;
        if (!selectedRowKeys.length) {
            message.warn('请选择需要下载返利单');
            return;
        }
        if (selectedRowKeys.length > 10) {
            message.warn('请勿勾选10个以上');
            return;
        }
        let url = `${config.server}/api/v1/dms/tzOrderSync/download?ids=` + selectedRowKeys;
        window.open(url);
    }

    info() {
        if (this.ouId == 82) {
            Modal.info({
                title: '销方发票抬头',
                content: (
                    <div>
                        <p>名称：浙江天正电气股份有限公司</p>
                        <p>税号：91330000717612987P</p>
                        <p>地址：乐清市柳市苏吕工业区</p>
                        <p>开户行：农行乐清经济开发区支行</p>
                        <p>行号：103333327062</p>
                        <p>账号：19270601040002121</p>
                        <p>电话：0577-62776776</p>
                    </div>
                ),
                onOk() {
                },
            });
        } else {
            Modal.info({
                title: '销方发票抬头',
                content: (
                    <div>
                        <p>名称：上海天毅行智能电气有限公司</p>
                        <p>税号：91310115MA7B4E4Y3N</p>
                        <p>地址：上海自由贸易试验区康桥东路388号8幢220室</p>
                        <p>开户行：招商银行股份有限公司上海周浦支行</p>
                        <p>账号：121942920310902</p>
                        <p>电话：021-31198730</p>
                    </div>
                ),
                onOk() {
                },
            });
        }
    }


    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            invoiceOrderStatus,
            signStatus,
            channel_list,
            selectedRowKeys,
            tempTotalAmount,
            tempTotal,
            button_limits_end,
            loading,
            gouxiaoUnitList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'invoiceCode',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.vatInvoiceCode
                },
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'purchaseName',
                    label: '开单购货单位',
                    text: '输入开单购货单位',
                    type: 'select',
                    defaultValue: searchObj.purchaseName,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'vatInvoiceNumber',
                    label: '增值税发票号码',
                    text: '输入增值税发票号码',
                    type: 'default',
                    defaultValue: searchObj.vatInvoiceNumber
                },
                {
                    name: 'taxpayerNumber',
                    label: '纳税人识别号',
                    text: '输入纳税人识别号',
                    type: 'default',
                    defaultValue: searchObj.taxpayerNumber
                },
                {
                    name: 'address',
                    label: '邮寄地址',
                    text: '输入邮寄地址',
                    type: 'default',
                    defaultValue: searchObj.address
                },
                {
                    name: 'courierNumber',
                    label: '快递单号',
                    text: '输入快递单号',
                    type: 'default',
                    defaultValue: searchObj.courierNumber
                },
                {
                    name: 'invoiceDate',//startCreatedDate, endCreatedDate
                    label: '开票日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.invoiceStarDate || '',
                        end: searchObj.invoiceEndDate || ''
                    },
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    options: invoiceOrderStatus,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.status
                },
                {
                    name: 'channel',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_list,
                    defaultValue: searchObj.channel,
                    multiple: false,//支持多选
                    type: 'select',
                },
                {
                    name: 'signStatus',
                    label: '签收状态',
                    text: '选择签收状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: 'R', text: '已签收'},
                        {value: '0', text: '未签收'},
                    ],
                    defaultValue: searchObj.signStatus,
                    multiple: false,//支持多选
                    type: 'select',
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'invoiceCode',
                    render: (text, record, index) => {
                        let tag = 'Normal';
                        if (record.orderType == '特殊开票') {
                            tag = 'Special';
                        }
                        return <a href={`#/invoiceManagement/${record.id}/${tag}`}>{text}</a>
                    }
                },
                {
                    title: '增值税发票号码',
                    dataIndex: 'vatInvoiceNumber'
                },
                {
                    title: '开票日期',
                    dataIndex: 'invoiceDate',
                    render: (text, record, index) => {
                        // console.log(text);
                        return text.split(' ')[0];
                    }
                },
                {
                    title: '纳税人识别号',
                    dataIndex: 'taxpayerNumber'
                },
                {
                    title: '客户编号',
                    dataIndex: 'cusNumber'
                },
                {
                    title: '开单购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '渠道',
                    dataIndex: 'channel'
                },
                {
                    title: '邮寄地址',
                    dataIndex: 'address'
                },
                {
                    title: '总金额（元）',
                    dataIndex: 'totalAmount'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '开票状态',
                    dataIndex: 'statusText'
                },
                {
                    title: '签收',
                    dataIndex: 'courierNumber',
                    render: (text, record, index) => {
                        if (record.courierNumber) {
                            if (button_limits_end.invoiceManagement_detail_01 == true &&
                                record.status != 'R') {
                                return <Button className="specialInvoice"
                                               onClick={this.confirmHandle.bind(this, record, index)}>确认签收</Button>
                            } else {
                                return <span>已签收</span>
                            }
                        } else {
                            return <span>未签收</span>
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: '',
                    width: '15%',
                    render: (text, record, index) => {
                        let tag = 'Normal';
                        if (record.orderType == '特殊开票') {
                            tag = 'Special';
                        }
                        if (record.status == 'N') {
                            return (<div>
                                <Button size='small' style={{display: 'inline-block', marginRight: '10px'}}
                                        onClick={this.goView.bind(this, `invoiceManagement/${record.id}/${tag}`)}>查看</Button>
                                <Popconfirm placement="left" title='您确定要删除吗！' onConfirm={() => {
                                    this.deleteRows(record.id)
                                }}>
                                    <Button size={'small'} type="danger">删除</Button>
                                </Popconfirm>
                            </div>)
                        } else {
                            return (<div>
                                <Button size='small' style={{display: 'inline-block', marginRight: '10px'}}
                                        onClick={this.goView.bind(this, `invoiceManagement/${record.id}/${tag}`)}>查看</Button>
                                <Button size='small' type="primary"
                                        style={{
                                            display: record.invoiceLink ? 'inline-block' : 'none',
                                            marginRight: '10px'
                                        }}
                                        onClick={this.downloadFile.bind(this, record.invoiceLink)}>PDF</Button>
                                <Button size='small' type="primary"
                                        style={{
                                            display: record.invoiceXmlLink ? 'inline-block' : 'none',
                                            marginRight: '10px'
                                        }}
                                        onClick={this.downloadFile.bind(this, record.invoiceXmlLink)}>XML</Button>
                                <Button size='small' type="primary"
                                        style={{display: record.invoiceOfdLink ? 'inline-block' : 'none'}}
                                        onClick={this.downloadFile.bind(this, record.invoiceOfdLink)}>OFD</Button>
                            </div>)
                        }
                    }
                },

            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        const iconLayout = {
            fontSize: '32px'
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew labelStyle={{width: "120px", marginLeft: "10px"}} {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {button_limits_end.invoiceManagement_list_03 &&
                        <a className="dms-table-a"
                           onClick={this.goView.bind(this, `/invoiceManagement/invoiceStaging`)}>
                            <i className="anticon anticon-exception" style={iconLayout}></i>&nbsp;&nbsp;&nbsp;
                            <span className="stagingCount">{tempTotal}</span>
                        </a>}
                    <span>暂存单共 {tempTotal} 条，总金额：{tempTotalAmount} 元</span>
                    {/*{ button_limits_end.invoiceManagement_list_01 && <Button style={{position:'absolute', bottom:8, right:116}} icon="minus" onClick={this.deleteChange}>删除</Button>} */}
                    <Button style={{position: 'absolute', bottom: 8, right: 200}}
                            onClick={this.info.bind(this)}>开票信息</Button>
                    {button_limits_end.invoiceManagement_list_02 &&
                        <Button style={{position: 'absolute', bottom: 8, right: 85}} icon="plus"
                                onClick={this.goView.bind(this, `/invoiceManagement/invoiceApplyStart`)}>开票申请</Button>}
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                    <Button style={{position: 'absolute', bottom: 8, right: 300}}
                            onClick={this.batchDownload}>批量下载</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(InvoiceList);



// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/list.js